import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import InputLedgerItemFormInput from 'components/singleLedgerItem/InputLedgerItemFormInput';
import { ItemFields } from 'const/ItemFields';
import { useEffect, useState } from 'react';

const CategoryAddModal = ({ isOpen, categoryToAdd, onClose, onClickCancelButton, handleAddCategory }) => {
    const [category, setCategory] = useState(categoryToAdd);

    const handleSubmit = e => {
        e.preventDefault();
        handleAddCategory(category);
    };

    const onChange = e => {
        setCategory({
            ...category,
            [e.target.name]: e.target.value,
        });
    };

    useEffect(() => {
        if (categoryToAdd) {
            setCategory(categoryToAdd);
        }
    }, [categoryToAdd]);

    return (
        <Dialog open={isOpen} onClose={onClose}>
            <form onSubmit={handleSubmit}>
                <DialogTitle>Add new category</DialogTitle>
                <DialogContent>
                    <InputLedgerItemFormInput
                        inputLabelName={ItemFields.CATEGORY.label}
                        name="name"
                        value={category?.name}
                        onChange={onChange}
                        required
                    />
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={onClickCancelButton}>
                        Cancel
                    </Button>
                    <Button type="submit" color="primary">
                        Save
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default CategoryAddModal;
